<template>
    <a-modal v-model="visible" :title="!!form.id ? '编辑权益' : '新增权益'" @ok="handleOk" :confirm-loading="confirmLoading"
        @cancel="handleCancel" :maskClosable="false" :keyboard="false">
        <draggable v-model="form.orderlist" :sort="true">
            <div v-for="(v, i) in form.orderlist" class="order-item">
                <div class="l1">
                    <a-icon type="border-outer" class="dynamic-delete-button" />
                    {{ v.project_name }}{{ v.tripproject_id }}
                </div>
                <!-- <div class="2">{{ i + 1 }}</div> -->
            </div>
        </draggable>
    </a-modal>
</template>
<script>
import draggable from "vuedraggable";
export default {
    components: { draggable, },
    data() {
        return {
            visible: false,
            confirmLoading: false,
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
            form: {
                trip_id: void 0,
                orderlist: []
            },
        }
    },
    methods: {
        init(trip_id) {
            this.visible = true;
            this.form.trip_id = trip_id;
            this.$http({
                url: "/admin/tripproject/page?trip_id=" + trip_id,
                method: "get",
            }).then((res) => {
                this.form.orderlist = res.data.result;
            });
        },
        handleOk() {
            this.confirmLoading = true;
            const orderlist = this.form.orderlist.map((v, i) => {
                return {
                    ...v,
                    sort: i + 1
                }
            })
            this.$http({
                url: '/admin/tripproject/sortproject',
                method: "post",
                data: {
                    orderlist
                },
            })
                .then(() => {
                    this.$message.success('操作成功');
                    this.handleCancel();
                    this.$emit("ok");
                })
                .finally(() => {
                    this.confirmLoading = false;
                });
        },
        handleCancel() {
            this.visible = false;
            this.form.trip_id = void 0;
            this.form.orderlist = []
            this.confirmLoading = false;
        },
    }
}
</script>
<style scoped>
.order-item {
    padding: 5px 0;
    font-size: 16px;
}

.dynamic-delete-button {
    margin-right: 5px;
}
</style>